const formatUserFullName = ({ firstName, lastName }: { firstName?: string; lastName?: string }) => {
  let formattedName = '';
  if (firstName) formattedName = `${firstName} `;
  if (lastName) formattedName = `${formattedName}${lastName}`;
  return formattedName.trim() || 'N/A';
};

export default formatUserFullName;
